var map = {
	"./aq/languages/en/button.json": [
		"f079",
		"chunk-2d22b9e2"
	],
	"./as/languages/en/button.json": [
		"3372",
		"chunk-2d0b9631"
	],
	"./ba/languages/en/button.json": [
		"089a",
		"chunk-2d0a4c46"
	],
	"./ia/languages/en/button.json": [
		"bfd2",
		"chunk-2d21b888"
	],
	"./oc/languages/en/button.json": [
		"0f8a",
		"chunk-2d0af8d5"
	],
	"./st/languages/en/button.json": [
		"5764",
		"chunk-2d0c8dd6"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bd53";
module.exports = webpackAsyncContext;